import React, {Component} from 'react';
import { t } from '@lingui/macro';
import {connect} from 'react-redux';
import Big from 'big.js';
import {Modal} from 'antd';
import ListMenu from "..";
import ContactActions from 'bukku/redux/Contact/actions';
import {checkContactTypeStatementReadable, isContactTypesPermitted} from 'bukku/containers/AppPage/Contacts/helper';
import queryString from 'query-string';
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
import { withI18n } from '@lingui/react';
import { ContactEntityType } from '../../../enums/ContactEntityType';
import { PermissionV2 } from '../../Access/helper/permission/enum/PermissionV2';

const {
    archiveContact,
    deleteContact,
    toggleMandateDrawer,
    toggleMandateModal,
    readContactMandate,
    sendMyInvoisEmail,
} = ContactActions;

class ContactListMenu extends Component {
    toggleActivation = record => {
        const { archiveContact } = this.props;
        const isArchived = record.is_archived;

        Modal.confirm({
            title: (isArchived ? t`Activate Contact` : t`Deactivate Contact`),
            content: isArchived ?
                t`Do you really want to activate contact ${record.legal_name}?` :
                t`Do you really want to deactivate contact ${record.legal_name}?`,
            onOk() {
                archiveContact(record.id, {
                    is_archived: !isArchived,
                });
            },
            onCancel() {},
            okText: (isArchived ? t`Activate` : t`Deactivate`),
            cancelText: t`Cancel`,
        });
    };

    deleteContact = record => {
        const { deleteContact } = this.props;

        Modal.confirm({
            title: t`Delete Contact`,
            content: t`Do you really want to delete contact ${record.legal_name}?`,
            onOk() {
                deleteContact(record.id);
            },
            onCancel() {},
            okText: t`Delete`,
            cancelText: t`Cancel`,
        });
    };

    toggleRequestEInvoiceInfo = record => {
        const {
            openDrawer,
        } = this.props;

        openDrawer(record, 'myInvoisDataRequest');
    };

    getItems = () => {
        const {
            record,
            openDrawer,
            // redux
            company,
            // readContactMandate,
            // toggleMandateDrawer,
            // toggleMandateModal,
        } = this.props;
        const items = [];

        items.push({
            key: 'view',
            label: t`View`,
            url: `/contacts/${record.id}`,
        });

        // if (record.types.indexOf('customer') !== -1) {

        const {
            DEBTOR,
            CREDITOR,
        } = checkContactTypeStatementReadable(record.types);
        const noReadStatementPermission = !(DEBTOR || CREDITOR);

        const isOnlyCREDITOR = DEBTOR === false && CREDITOR === true;

        // const contactCategories = getContactTypeInfos(record.types, 'category');
        // const isOnlyCREDITOR = (
        //     !contactCategories.includes(ContactCategory.DEBTOR) &&
        //     contactCategories.includes(ContactCategory.CREDITOR)
        // ); // contact is solely CREDITOR (supplier and/or employee)

        // console.log('aaa contact list menu', {record, contactCategories, isOnlyCREDITOR});

        const receivableAmount = record.receivable_amount ? new Big(record.receivable_amount) : null;
        const payableAmount = record.payable_amount ? new Big(record.payable_amount) : null;

        const params = {
            contact_id: record.id,
            type: isOnlyCREDITOR ? 'CREDITOR' : 'DEBTOR',
        };
        const paramString = queryString.stringify(params, { arrayFormat: 'bracket' });

        const viewStatementItem = {
            key: 'viewStatement',
            label: t`Statement`,
            url: `/contacts/statement?${paramString}`, // to init
            subscription: SubscriptionScopeKey['CONTACT.STATEMENT'],
            isHidden: noReadStatementPermission, // hide if contact is neither DEBTOR nor CREDITOR (eg: no READ permissions to any type of the contact)
        };
        // if (
        //     (contactCategories.includes('DEBTOR') &&
        //         !receivableAmount.eq(0)) ||
        //     (contactCategories.includes('CREDITOR') && !payableAmount.eq(0)))
        if (
            (DEBTOR === true && receivableAmount) ||
            (CREDITOR === true && payableAmount)
        )
            items.unshift(viewStatementItem);
        else
            items.push(viewStatementItem);

        const quickShareSubmenu = [
            {
                key: 'quickShareEmail',
                label: t`via Email`,
                action: () => openDrawer(record, 'send'),
                subscription: SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT'],
            },
            {
                key: 'quickShareLink',
                label: t`via Link`,
                action: () => openDrawer(record, 'share'),
                subscription: SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT'],
            },
        ];
        items.push({
            key: 'quickShare',
            label: t`QuickShare...`,
            submenu: quickShareSubmenu,
            subscription: SubscriptionScopeKey['CONTACT.STATEMENT.E_STATEMENT'],
            isCreate: true,
            isHidden: noReadStatementPermission,
        });

        // }
        // if (!record.mandate || record.mandate?.status === 'REJECTED') {
        //     items.push({
        //         key: 'create_mandate',
        //         label: t`Create Mandate`,
        //         action: () => toggleMandateDrawer(true, 'create', record),
        //         isUpdate: true,
        //     });
        // }

        // if (record.mandate && record.mandate.status !== 'REJECTED') {
        //     items.push({
        //         key: 'update_mandate',
        //         label: t`Update Mandate`,
        //         action: () => {
        //             readContactMandate(record.id);
        //             toggleMandateDrawer(true, 'update', record);
        //         },
        //         isUpdate: true,
        //     });

        //     items.push({
        //         key: 'delete_mandate',
        //         label: t`Delete Mandate`,
        //         action: () => toggleMandateModal(true, record),
        //         type: 'danger',
        //         isUpdate: true,

        //     });
        // }

        if (company?.country_code === "MY") {
            items.push({
                key: 'e-invoice-email',
                label: t`Request Data (MyInvois)`,
                disabled: record.is_archived || record?.entity_type === ContactEntityType.GENERAL_PUBLIC.key,
                action: () => this.toggleRequestEInvoiceInfo(record),

            });
        }

        if (record.is_archived) {
            items.push({
                key: 'activate',
                label: t`Activate`,
                action: () => this.toggleActivation(record),
                isHidden: !isContactTypesPermitted(record.types, PermissionV2.update, "OR")
            });
        }
        else {
            items.push({
                key: 'deactivate',
                label: t`Deactivate`,
                action: () => this.toggleActivation(record),
                isHidden: !isContactTypesPermitted(record.types, PermissionV2.update, "OR"),
            });
        }

        // Delete
        items.push({
            key: 'delete',
            label: t`Delete`,
            disabled: record.is_used,
            action: () => this.deleteContact(record),
            isHidden: !isContactTypesPermitted(record.types, PermissionV2.delete, "OR"),
        });

        return items;
    };

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(state => ({
    company: state.Auth.company,
}), {
    archiveContact,
    deleteContact,
    toggleMandateDrawer,
    toggleMandateModal,
    readContactMandate,
    sendMyInvoisEmail,
})(withI18n()(ContactListMenu));
